<template>
  <div id="prices">
    <hr class="solid" />
    <div class="row">
      <h3 class="mb-3 mt-2" style="margin-bottom: 30px !important">
        {{ $t("components.prices.common.prices") }}
      </h3>
      <div class="table-responsive">
        <slot></slot>
        <table class="table table-striped">
          <colgroup>
            <col width="30%" />
            <col width="30%" />
            <col width="40%" />
          </colgroup>

          <tbody>
            <tr>
              <td class="background-color-primary text-light align-middle">
                {{ $t("components.prices.common.date") }}
              </td>
              <td class="background-color-primary text-light align-middle">
                {{ $t("components.prices.common.price") }}
              </td>
              <td class="background-color-primary text-light align-middle">
                {{ $t("components.prices.common.additionalCosts") }}
              </td>
            </tr>

            <template v-for="(price, index) in sortedPrices">
              <tr :key="price.id">
                <td style="border-top-width: 2px">
                  {{ price.startDate | dateFormat }} -
                  {{ price.endDate | dateFormat }}
                </td>
                <td style="border-top-width: 2px">
                  <template v-if="validPrice(price.pricePerDay)">
                    <strong
                      >{{ price.currency }} {{ price.pricePerDay }}.-
                      {{ $t("components.prices.common.perDay") }}</strong
                    >
                    <br />
                  </template>
                  <strong v-if="validPrice(price.pricePerWeek)">
                    {{ price.currency }} {{ price.pricePerWeek }}.-
                    {{ $t("components.prices.common.perWeek") }} (7
                    {{ $t("components.prices.common.nights") }})
                  </strong>
                </td>
                <td style="border-top-width: 2px">
                  <ul class="list-unstyled">
                    <li v-if="validPrice(price.finalCleaning)">
                      {{ $t("components.prices.common.finalCleaning") }}:
                      {{ price.currency }} {{ price.finalCleaning }}.-
                    </li>
                    <li v-if="validPrice(price.linensPerPerson)">
                      {{ linensTranslation(price) }}: {{ price.currency }}
                      {{ price.linensPerPerson }}.-
                    </li>
                    <li v-if="validPrice(price.pets)">
                      {{ $t("components.prices.common.pets") }}:
                      {{ price.currency }} {{ price.pets }}.-
                    </li>
                    <li v-if="validPrice(price.accessory)">
                      {{ $t("components.prices.common.accessoryCosts") }}:
                      {{ price.currency }} {{ price.accessory }}.-
                    </li>
                    <li v-if="validPrice(price.totalExtras)">
                      {{ $t("components.prices.common.totalExtras") }}:
                      {{ price.currency }} {{ price.totalExtras }}.-
                    </li>
                    <li v-if="validPrice(price.minimumStay)">
                      {{ $t("components.prices.common.minimumStay") }}:
                      {{ price.minimumStay }}
                      {{ $t("components.prices.common.nights") }}
                    </li>
                    <li
                      v-if="
                        validPrice(price.startDateSaturday) &&
                        price.startDateSaturday
                      "
                    >
                      {{ $t("components.prices.common.startDateSaturday") }}
                    </li>
                    <li
                      v-if="
                        validPrice(price.endDateSaturday) &&
                        price.endDateSaturday
                      "
                    >
                      {{ $t("components.prices.common.endDateSaturday") }}
                    </li>
                    <li v-if="price.extraTaxOlder">
                      {{ $t("components.prices.common.olderTax") }}
                    </li>
                  </ul>
                  <a
                    class="accordion-toggle collapsed"
                    data-toggle="collapse"
                    :href="`#collapseComment_${index}`"
                    aria-expanded="false"
                  >
                    <strong
                      ><span
                        data-toggle="tooltip"
                        data-placement="left"
                        title=""
                        data-original-title="Klick für Details"
                        >{{ $t("common.placeholders.moreInfo") }} [...]</span
                      ></strong
                    >
                  </a>
                </td>
              </tr>
              <tr :key="`disc_${price.id}`">
                <td
                  colspan="4"
                  style="
                    padding: 0px !important;
                    border: 0px !important;
                    height: 0px !important;
                  "
                >
                  <div
                    :id="`collapseComment_${index}`"
                    class="collapse"
                    style=""
                  >
                    <div class="card-body">
                      <p style="margin-bottom: 0px; white-space: pre-line">
                        {{ price.notes }}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StaticPrices",
  props: {
    prices: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    validPrice: function (priceField) {
      return (
        priceField !== undefined && priceField !== null && priceField !== 0
      );
    },
    linensTranslation: function (price) {
      return price.linensIncludeTowels
        ? this.$i18n.t("components.prices.common.linensPerPerson")
        : this.$i18n.t("components.prices.common.linensPerPersonWithoutTowels");
    },
  },
  computed: {
    sortedPrices: function () {
      let recurring = this.prices
        .filter((el) => el.type === "RECURRING")
        .sort((a, b) => {
          let aStartDate = `2000-${a.startDate}`;
          let bStartDate = `2000-${b.startDate}`;

          return new Date(aStartDate) - new Date(bStartDate);
        });
      let standard = this.prices
        .filter((el) => el.type === "STANDARD")
        .sort((a, b) => {
          return new Date(a.startDate) - new Date(b.startDate);
        });

      return standard.concat(recurring);
    },
  },
};
</script>

<style lang="less" scoped></style>
